import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context';
import { LoadingDots } from '../loading';

export const ProtectedPage = ({ children, pathname }) => {
  const { user, initialized } = useContext(UserContext);
  const navigate = useNavigate();

  if (initialized && !user) {
    navigate(`/inloggen${pathname ? `?next=${pathname}` : ''}`, { replace: true });
  }
  if (initialized && user) {
    return <>{children}</>;
  }
  return <LoadingDots />;
};
